'use client';

import { useEffect } from 'react';

export const useGlobalScreenHeight = () => {
  useEffect(() => {
    const setGlobalScreenHeight = () => {
      const vh = Math.max(
        document.documentElement.clientHeight || 0,
        window.innerHeight || 0
      );
      document.documentElement.style.setProperty('--svh', `${vh}px`);
    };
    setGlobalScreenHeight();
  }, []);
};
